export default {"src":"/_next/static/media/zwemsport.17e7ea14.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};